import { render, staticRenderFns } from "./brief.vue?vue&type=template&id=15cc2b3e"
import script from "./brief.vue?vue&type=script&lang=js"
export * from "./brief.vue?vue&type=script&lang=js"
import style0 from "./brief.vue?vue&type=style&index=0&id=15cc2b3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports